import { DatabaseHistoryRow } from '../../models/Auditing/database-history-row';
import DataGrid, {
    Column,
    HeaderFilter,
    Toolbar,
    Item,
    Selection,
    LoadPanel
} from 'devextreme-react/data-grid';

interface Props {
    data: DatabaseHistoryRow[];
    isLoading: boolean;
}

export default function DocumentHistory(props: Props) {

    return (
        <div id="document-history-container">
            <div id="document-history-datagrid-container" className="pw-datagrid">
                <DataGrid id="document-history-datagrid"
                    data-testid="document-history-datagrid"
                    dataSource={props.data}
                    noDataText=""
                    height="15rem"
                    showRowLines={true}
                    showBorders={true}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                >
                    <LoadPanel enabled />
                    <HeaderFilter visible={true} />
                    <Selection mode="single" />

                    <Column dataField='modifyTimestamp' caption="Timestamp" dataType="datetime" format="yyyy-MM-dd HH:mm:ss" width="10rem" />
                    <Column dataField="modifyUser" caption="User" dataType="string" width="10rem" />
                    <Column dataField='value' caption="Value" dataType="string" />

                    <Toolbar>
                        <Item location="before">
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Status History</div>
                            </div>
                        </Item>
                    </Toolbar>
                </DataGrid>
            </div>
        </div>
    );
}
